import { render, staticRenderFns } from "./custom-item.vue?vue&type=template&id=4618f3e1&scoped=true"
import script from "./custom-item.vue?vue&type=script&lang=js"
export * from "./custom-item.vue?vue&type=script&lang=js"
import style0 from "./custom-item.vue?vue&type=style&index=0&id=4618f3e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4618f3e1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonImage: require('/builds/wj/fe/wenjuan-homesite/components/common/image.vue').default,CommonSvg: require('/builds/wj/fe/wenjuan-homesite/components/common/svg.vue').default})
